import React from 'react';
import { useContext } from '../Context'
import { numToPercent } from '../constants';
import he from 'he'

const TopMatches = () => {
    const { globalState } = useContext()
    const { topMatches, devMode } = globalState


    return (
        <div>
            {topMatches && topMatches.length > 0 ? (
                <ul className='image-list matches-list'>
                    {topMatches.map((match, index) => (
                        <li key={index}>

                            <div className="position-relative py1 similarity-container">
                                <img alt={match.name} src={match.thumbnail_url} />
                                {devMode && <div className="similarity">{numToPercent(match.similarity)}</div>}
                            </div>
                            <p className='force-break lines'><a className="App-link" href={match.url} target="_blank" rel="noreferrer">{he.decode(match.name)} {/* Decode HTML entities safely */}</a></p>
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No images in the library</p>
            )}
        </div>

    );
};

export default TopMatches;